<span [id]="id" class="prefilled-field-badge">
  <span
    class="material-symbols-outlined prefilled-field-badge-icon"
    aria-hidden="true"
    >edit_off</span
  >
  <span class="prefilled-field-badge-text">{{ labelKey | translate }}</span>
</span>
